import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import LowIncomeFirstTimeBuyerGrants from "@/pages/tools/LowIncomeFirstTimeBuyerGrants";

export const Route = createFileRoute("/tools/low-income-first-time-buyer-grants")({
  head: () => seoHead("/tools/low-income-first-time-buyer-grants"),
  component: LowIncomeFirstTimeBuyerGrants,
});